angular.module('impactx.contentservicebrowser').controller('FolderNameDialogCtrl', ['$scope', '$mdDialog', 'TranslationService', 'themeFactory',
    'header', 'inputLabel', FolderNameDialogCtrl]);

function FolderNameDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, header, inputLabel)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.theme = themeFactory.getTheme();
    $scope.header = header;
    $scope.inputLabel = inputLabel;
    $scope.folderName = {value: ""};
    var self = this;

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide($scope.folderName.value);
    };
}